import React, { useState, useEffect } from "react";
import UsersListLayer from "../components/UsersListLayer";
import { useAuth } from "../contexts/AuthContext";
import { Icon } from '@iconify/react';
import AdminWiseDetailsModal from "../components/modals/AdminWiseDetailsModal";

const UsersListPage = () => {
  const { profile } = useAuth();
  const [filter, setFilter] = useState("daily");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [openAdminWiseDetails, setOpenAdminWiseDetails] = useState(false);

  const formatDate = (date) => date.toISOString().split("T")[0];

  useEffect(() => {
    const daily = new Date();
    let start, end;

    switch (filter) {
      case "daily":
        start = end = daily;
        break;
      case "weekly":
        start = new Date(daily);
        start.setDate(daily.getDate() - 6);
        end = daily;
        break;
      case "monthly":
        start = new Date(daily.getFullYear(), daily.getMonth(), 1);
        end = new Date(daily.getFullYear(), daily.getMonth() + 1, 0);
        break;
      case "yearly":
        start = new Date(daily.getFullYear(), 0, 1);
        end = new Date(daily.getFullYear(), 11, 31);
        break;
      case "custom":
        return; // Don't auto-set dates for custom filter
      default:
        return;
    }

    setStartDate(formatDate(start));
    setEndDate(formatDate(end));
  }, [filter]);

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const handleDateChange = (e, dateType) => {
    const value = e.target.value;
    if (dateType === 'start') {
      setStartDate(value);
      // If end date is before start date, update end date
      if (end_date && value > end_date) {
        setEndDate(value);
      }
    } else {
      // Don't allow end date to be before start date
      if (!start_date || value >= start_date) {
        setEndDate(value);
      }
    }
  };

  const handleClear = () => {
    setFilter("daily");
    setStartDate("");
    setEndDate("");
  };

  return (
    <>
      <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
        <h6 className='fw-semibold mb-0'>Users</h6>
        <div className="d-flex gap-2 flex-wrap align-items-center">
          {profile?.user_type === 'superadmin' && (
            <button
              className="btn btn-sm btn-primary-600 px-16 py-8 radius-8 d-flex align-items-center gap-2"
              onClick={() => setOpenAdminWiseDetails(true)}
            >
              <Icon icon="solar:chart-outline" className="text-lg" />
              View Admin Wise Details
            </button>
          )}
          <select
            className='form-select form-select-sm w-auto bg-base border text-secondary-light'
            value={filter}
            onChange={handleFilterChange}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
            <option value="custom">Custom</option>
          </select>

          {filter === "custom" && (
            <>
              <input
                type="date"
                className="form-control form-control-sm w-auto"
                value={start_date}
                onChange={(e) => handleDateChange(e, 'start')}
                max={end_date || undefined}
              />
              <span>to</span>
              <input
                type="date"
                className="form-control form-control-sm w-auto"
                value={end_date}
                onChange={(e) => handleDateChange(e, 'end')}
                min={start_date || undefined}
              />
            </>
          )}

          {filter !== "weekly" && (
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={handleClear}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      <UsersListLayer 
        filter={filter} 
        start_date={start_date} 
        end_date={end_date}
      />

      <AdminWiseDetailsModal
        open={openAdminWiseDetails}
        onClose={() => setOpenAdminWiseDetails(false)}
        filter="users"
      />
    </>
  );
};

export default UsersListPage;
